import { isDefined } from '@sgme/fp';

export const isPrintableKey = (eventKey?: string | null): eventKey is string =>
  isDefined(eventKey) && eventKey.length === 1;
